import { useComments } from '../../../hooks/use-comments';
import { useUserInfo } from '../../../hooks/use-user-info';
import { Comment } from './comment';
import { CommentForm } from './comment-form';
import './comments-panel.css';

interface CommentsProps {
  entityId: string;
  userId?: number;
}

interface CommentData {
  id: string;
  content: string;
  userId: string;
  createdAt: string;
}

export const CommentsPanel = ({ entityId, userId }: CommentsProps) => {
  const { comments, loading, error, addComment } = useComments({ entityId });
  const { userInfoMap } = useUserInfo(comments as CommentData[]);

  return (
    <div className="comments-panel">
      <CommentForm 
        userId={userId} 
        loading={loading} 
        onSubmit={(content) => addComment(content, userId as number)} 
      />

      {error && <div className="comments-error">{error}</div>}

      <div className="comments-list">
        {loading && comments.length === 0 ? (
          <div className="comments-loading">Loading comments...</div>
        ) : comments.length > 0 ? (
          comments.map((comment) => {
            const userIdNum = parseInt(comment.userId, 10);
            const userInfo = !isNaN(userIdNum) ? userInfoMap[userIdNum] : undefined;

            return (
              <Comment
                key={comment.id}
                comment={comment as CommentData}
                userInfo={userInfo}
              />
            );
          })
        ) : (
          <div className="no-comments">
            No comments yet. Be the first to comment!
          </div>
        )}
      </div>

      {loading && comments.length > 0 && (
        <div className="comments-loading-overlay">
          <div className="comments-loading">Updating comments...</div>
        </div>
      )}
    </div>
  );
};
